import { useContext } from 'react'
import PropTypes from 'prop-types'

import { OEContext } from '@aytm/app/stats/page/comments'

import ClickOutside from '@aytm/lib/rfd-ui/components/basic/click-outside'

import { Checkbox } from 'primereact/checkbox'
import { RadioButton } from 'primereact/radiobutton'

import Dropdown from '@aytm/lib/rfd-ui/components/basic/dropdown'

import style from '@aytm/app/stats/page/comments/styles/dropdown.module.scss'
import { DEFAULT_SELECTED_QUESTION } from '@aytm/app/stats/page/components/lib/constants'

const ResponseDropdown = ({
  responseId,
  opened,
  hasQuestionOrder,
  isResponseOrder,
  isShowOtherResponses,
  isShowTraits,
  onUpdateParams,
  onToggleResponseOrder,
  onToggleTraits,
  onClickOutside
}) => {
  const { searchState } = useContext(OEContext)
  const { selectedQuestion } = searchState.request

  const onResponseClick = () => {
    onUpdateParams({ query: [{ value: responseId, label: responseId, type: 'uid' }] }, undefined, 'comments')
  }

  return (
    <Dropdown className={style['settings-dropdown']} width="auto" align="right" opened={opened}>
      {() => (
        <ClickOutside onClickOutside={event => setTimeout(() => onClickOutside(event))}>
          <ul className={`${style['settings-dropdown-options']} p-mod-small`}>
            {(selectedQuestion == DEFAULT_SELECTED_QUESTION || isShowOtherResponses) && hasQuestionOrder ? (
              <>
                <li className={style['settings-dropdown-option']}>
                  <RadioButton
                    checked={!isResponseOrder}
                    disabled={!hasQuestionOrder}
                    onChange={hasQuestionOrder ? onToggleResponseOrder.bind(this, false) : null}
                  />
                  <span
                    className={style['settings-dropdown-option-label']}
                    onClick={hasQuestionOrder ? onToggleResponseOrder.bind(this, false) : null}
                  >
                    Qs in survey order
                  </span>
                </li>
                <li className={style['settings-dropdown-option']}>
                  <RadioButton
                    checked={isResponseOrder}
                    disabled={!hasQuestionOrder}
                    onChange={hasQuestionOrder ? onToggleResponseOrder.bind(this, true) : null}
                  />
                  <span
                    className={style['settings-dropdown-option-label']}
                    onClick={hasQuestionOrder ? onToggleResponseOrder.bind(this, true) : null}
                  >
                    Qs in response order
                  </span>
                </li>
              </>
            ) : null}
            {onToggleTraits ? (
              <li className={style['settings-dropdown-option']}>
                <Checkbox checked={isShowTraits} onChange={onToggleTraits} />
                <span className={style['settings-dropdown-option-label']} onClick={onToggleTraits}>
                  Show traits
                </span>
              </li>
            ) : null}
            {searchState.isVideoResponsesMode ? (
              <li className={style['settings-dropdown-option']} onClick={onResponseClick}>
                <i className="icon-aytmfd-qoeform" />
                <span className={style['settings-dropdown-option-label']}>Open response</span>
              </li>
            ) : null}
          </ul>
        </ClickOutside>
      )}
    </Dropdown>
  )
}

ResponseDropdown.propTypes = {
  responseId: PropTypes.number,
  opened: PropTypes.bool,
  hasQuestionOrder: PropTypes.bool,
  isResponseOrder: PropTypes.bool,
  isShowOtherResponses: PropTypes.bool,
  isShowTraits: PropTypes.bool,
  onUpdateParams: PropTypes.func,
  onToggleOtherResponses: PropTypes.func,
  onToggleResponseOrder: PropTypes.func,
  onToggleTraits: PropTypes.func,
  onClickOutside: PropTypes.func
}

ResponseDropdown.displayName = 'ResponseDropdown'

export default ResponseDropdown
